module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/rMeG1C/tc-custom/9781611528138.jpg?1723403860450",
      "alt": "This image is the cover for the book Kindred Spirit, Lovers and Liars"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Kindred Spirit, Lovers and Liars\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In the summer of 1944, Leslie Atwater -- feeling abandoned by his lover Edward -- rushes to London to enlist in the armed services. After failing the physical, he retreats to the sanctuary of St. Michael’s rectory and to the love and support of his brother Robert."), _c('br'), _c('br'), _vm._v("When a bomb explodes near St. Andrew’s Home for Boys, it unearths a skeleton of an adolescent. As Leslie, Edward, and Robert set about identifying the remains, the shocking discovery stirs up an old antagonism between the two brothers and brings to light a string of repressed memories for Leslie."), _c('br'), _c('br'), _vm._v("With the truth obscured by the passage of years, can Leslie and Edward sift through the lies and subterfuge to track down the coldhearted killer of a kindred spirit?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Paul Alan Fahey\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0